import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import memoize from 'lodash/memoize';

import InputGroup from './InputGroup';
import * as validators from './validators';
import { PriceFormatter } from '../../lib/common';
import { useTranslation } from 'react-i18next';


function stringToPercentage(string) {
  if (!string || typeof string !== 'string') {
    return 0;
  }
  return parseInt(string.replace(/\D/g, ''), 10) / 10000;
}

function percentageToString(cents) {
  const priceFormatter = PriceFormatter({ decimals: 2, currency: '' });
  return priceFormatter(cents * 100).trim();
}

const formatValue = value => (value > 0 ? `${(Math.max(0, Math.min(1, value)) * 100).toFixed(0)}` : '');

function PercentageInput({ defaultValue, ...otherInputProps }) {

  return (
    <InputGroup
      {...otherInputProps}
      type="text"
      placeholder={formatValue(defaultValue)}
      defaultValue={formatValue(defaultValue)}
      inputAddonAfter="%"
    />
  );
}

PercentageInput.propTypes = {
  defaultValue: PropTypes.number.isRequired,
};

const extendedPercentageInput = compose()(PercentageInput);
extendedPercentageInput.normalize = stringToPercentage;
extendedPercentageInput.format = percentageToString;
extendedPercentageInput.validator = memoize(
  validators.ltEqNull(1, () => 'Procentsatsen får vara max 100%'),
);

export default extendedPercentageInput;
